export default __webpack_public_path__ + "static/media/cloud.18adb934.jpg";